export enum ListType {
  VIEWED = 'viewed',
  ORDERED = 'ordered',
  IN_CART = 'inCart',
  FREQUENTLY_ORDERED = 'frequentlyOrdered',
  DEFAULT = 'default', //neu anlegbare FavListen
  SALES_STAFF = 'salesStaff',
  FAVORITES = 'favorites', //Standard FavList nach Registrierung
}
